<template>
    <div v-if="isActiveLayout"
         class="active-layout"
    >
        <div class="active-layout__main">
            <span class="task-column task-name strong">
                {{ task.name }}
            </span>
            <span class="task-column task-started help-text">
                {{  prettifyDateTime(task.addedAt) }}
            </span>
            <span class="task-column task-status-msg help-text">
                {{ currentStatus }}
            </span>
            <span class="task-column task-abort">
                <i @click="abortTask(task)" class="fas fa-window-close"></i>
            </span>
        </div>
        <div class="progress-bar">
            <div
                class="progress-bar__level"
                :class="{
                    'progress-bar__level--floating': !showProgress,
                    'progress-bar__level--pulsing': showProgress
                }"
                :style="progressLevelStyle"
            >
            </div>
        </div>
    </div>
    <div v-else-if="isFinishedLayout"
        class="finished-layout"
    >
        <span class="task-name strong" :title="task.name">{{ task.name }}</span>
        <span class="task-started help-text">
            {{ prettifyDateTime(task.addedAt) }} -
            {{ prettifyDateTime(task.result.timeFinished) }}
        </span>
        <TaskResults
                v-bind:task="task"
                @click-on-show-graph-icon="clickOnShowDrawIcon"
                @click-on-show-detailed-task-info-icon="clickOnShowDetailedTaskInfoIcon"
                class="task-results"/>
    </div>
    <div
        v-else-if="isErrorLayout"
        class="error-layout">
        <span class="task-name strong">{{ task.name }}</span>
        <span class="task-started help-text">{{ prettifyDateTime(task.addedAt) }}</span>
        <ErrorResults
                v-bind:task="task" class="task-results"
                @click-on-show-detailed-task-info-icon="clickOnShowDetailedTaskInfoIcon" />
    </div>
</template>

<script>
import moment from 'moment'
import TaskResults from "./TaskResults";
import ErrorResults from "./ErrorResults";

moment.locale('ru')

export default {
  name: 'TaskListItem',
  components: {
    ErrorResults,
    TaskResults
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    taskStates() {
      return this.$store.state.taskStates
    },
    isActiveLayout() {
      return this.task.state === this.taskStates.active ||  this.task.state === this.taskStates.pending
    },
    isFinishedLayout() {
      return this.task.state === this.taskStates.finished
        || this.task.state === this.taskStates.archived
    },
    isErrorLayout() {
      return this.task.state === this.taskStates.error
    },
    showProgress() {
      return this.task.progress !== undefined && this.task.progress.total !== -1
    },
    progressLevelStyle() {
      const minWidthPercents = 5
      const actualProgressPercents = this.currentProgress * 100
      const widthToShowPercents = actualProgressPercents > minWidthPercents ? actualProgressPercents : minWidthPercents

      if (this.showProgress) {
        return {
          width: `${widthToShowPercents}%`
        }
      } else {
        return {}
      }
    },
    currentProgress() {
      if (this.task.progress === undefined) {
        return 0
      }
      return this.task.progress.done / this.task.progress.total
    },
    currentStatus() {
      if (this.task.state === this.taskStates.pending) {
        return 'Ожидает очереди...'
      }

      return this.task.progress.status
    }
  },
  methods: {
    prettifyDateTime(timeStart) {
      const momentObj =  moment.unix(timeStart)
      return momentObj.calendar(null, {
        sameDay: 'Сегодня h:mm',
        nextDay: 'Завтра h:mm',
        lastWeek: 'D MMMM',
        sameElse: 'D MMMM'
      });
    },
    async abortTask(task) {
      await this.$store.dispatch("abortTask", task)
    },
    clickOnShowDrawIcon() {
      this.$emit('click-on-show-graph-icon', this.task.result.methodResult)
    },
    clickOnShowDetailedTaskInfoIcon(task) {
      this.$emit('click-on-show-detailed-task-info-icon', task)
    },
    toggleRightSidebarState() {
      this.$store.commit('toggleSidebarState')
    }
  }
}
</script>

<style lang="sass" scoped>

    .error-results
        display: flex
        height: 24px
        flex-shrink: 0
        svg
            width: 16px
            path
                fill: #a94442 !important
            &:focus
                outline: none
        svg
            &:hover
                cursor: pointer
                path
                    fill: currentColor

    svg
        &:hover
            path
                fill: #5CA5D4

    .icon
        color: #636363
        text-align: center
        margin: 0 gridSteps(1) 0 gridSteps(1)
        width: 24px
        height: 24px
        &:hover
            color: #5CA5D4
            cursor: pointer

    .graph-icon-wrapper
        position: relative
        top: 3px

    .finished-layout, .active-layout__main, .error-layout
        display: flex

    .active-layout__main
        margin-bottom: gridSteps(2)

    .active-layout
        justify-content: flex-start

    .task-name
        width: gridSteps(18)
        flex: 1
        overflow: hidden

    .task-started
        flex: 1
        padding-left: gridSteps(2)
        width: gridSteps(12)

    .task-column
        flex-grow: 1
        /*flex-shrink: 0.2*/ // Степень сжатия fkex-контаейнера
        padding-right: gridSteps(2)

    .task-abort
        position: relative
        padding: 0
        width: gridSteps(2.5)
        color: #a94442
        i:hover
            color: red
        i:active
            color: #a94442
        i
            position: absolute
            /*font-size: 15px*/
            right: 0


    .task-status-msg
        text-align: right

    .task-results
        flex-grow: 1
        flex-shrink: 1
        position: relative
        text-align: right
        display: flex
        justify-content: flex-end
        padding-left: gridSteps(1)
        min-width: gridSteps(14)
        max-width: gridSteps(14)


    .progress-bar
        height: gridSteps(1)
        width: 100%
        overflow: hidden
        background: $light-blue
        position: relative

    .progress-bar__level
        height: 100%
        background: $blue
        width: gridSteps(1)
        position: absolute
        top: 0
        left: 0
        transition: width 400ms

        &--floating
            animation: loading 2s infinite

        &--pulsing
            animation: pulsing 2s infinite

    .error-msg
        color: $error-red

    @keyframes loading
        0%
            left: 0
            transform: scaleX(1)

        20%
            transform: scaleX(10)

        100%
            left: 110%
            transform: scaleX(1)

    @keyframes pulsing
        0%
            opacity: 1

        50%
            opacity: 0.5

        100%
            opacity: 1
</style>
